import React from "react" ;

const NavRowComponent = (props) =>
{
    const onCancel = () =>
    {
        // Should be implemented in inherited class
    }

    const doNextButton = () =>
    {
        if (props.navigationNotifier != null)
        {
            props.navigationNotifier('next');
        }
    }

    const doPrevButton = () =>
    {
        if (props.navigationNotifier != null)
        {
            props.navigationNotifier('prev');
        }
    }

    const setDisplayErrors = ( value )  =>
    {
        if (props.setDisplayErrors !== null && props.setDisplayErrors !== undefined )
        {
            props.setDisplayErrors ( value ) ;
        }
    }

    const isFormValid = () =>
    {
        if ( props.formIsValid !== null && props.formIsValid !== undefined )
        {
            return props.formIsValid() ;
        }
        else
        {
            return true ;
        }
    }

    const onNext = () =>
    {
        if (!isFormValid())
        {
            setDisplayErrors( true ) ;
        }
        else
        {
            doNextButton();
        }
    }

    const getNextButtonClickHandler = (params) =>
    {
        let nextHandler = onNext;

        if (params !== null && params !== undefined && params.onNext !== null && params.onNext !== undefined)
        {
            nextHandler = params.onNext;
        }

        return nextHandler;
    }

    const getCancelButtonClickHandler = (params) =>
    {
        let cancelHandler = onCancel;

        if (params !== null && params !== undefined && params.onCancel !== null && params.onCancel !== undefined)
        {
            cancelHandler = params.onCancel;
        }

        return cancelHandler;
    }

    const onPrevious = () =>
    {
        if (!isFormValid())
        {
            setDisplayErrors( true ) ;
        }
        else
        {
            doPrevButton();
        }
    }

    const colNextButton = (cols, params) =>
    {
        return (
            <div key='colNextButtonDiv' className={'col-md-' + cols}>
                <ul key='colNextButtonDivUL' className='pager'>
                    <li key='colNextButtonDivLI' className='next formnext'>
                        <a href='#' onClick={getNextButtonClickHandler(params)}>Next</a>
                    </li>
                    {props.cancelButtonRequired === true && <li key='colCancelButtonDivLI' className='next formcancel'>
                        <a href='#' onClick={getCancelButtonClickHandler(params)}
                           style={{marginRight: '10px'}}>Cancel</a>
                    </li>}
                </ul>
            </div>
        );
    }

    const colSaveButton = (cols, params) =>
    {
        if (props.saveButtonState === 'disabled')
        {
            return (
                <div key='colSaveButtonDiv' className={'col-md-' + cols}>
                    <ul key='colSaveButtonDivUL' className='pager'>
                        <li key='colSaveButtonDivLI' className='next formnext'>
                            <a href='#'
                               style={{color: 'white', backgroundColor: 'rgb(141,141,141)', cursor: 'wait'}}>Save</a>
                        </li>
                    </ul>
                </div>
            );
        } else
        {
            return (
                <div key='colSaveButtonDiv' className={'col-md-' + cols}>
                    <ul key='colSaveButtonDivUL' className='pager'>
                        <li key='colSaveButtonDivLI' className='next formnext'>
                            <a href='#' onClick={getNextButtonClickHandler(params)}
                               style={{color: 'white', backgroundColor: 'rgb(14,180,141)', cursor: 'pointer'}}>Save</a>
                        </li>
                    </ul>
                </div>
            );
        }
    }

    const colPrevButton = (cols, params) =>
    {
        return (
            <div key='colPrevButtonDiv' className={'col-md-' + cols}>
                <ul key='colPrevButtonDivUL' className='pager'>
                    <li key='colPrevButtonDivLI' className='previous'>
                        <a href='#' onClick={onPrevious}>Previous</a>
                    </li>
                </ul>
            </div>
        );
    }

    const colNoButtons = (cols, keyVal) =>
    {
        return <div key={'colNoButtonDiv' + keyVal} className={'col-md-' + cols}/>
    }

    const buttonRowMultiPage = (params) =>
    {
        let lineList = [];

        if (props.prevButtonRequired)
        {
            lineList.push(colPrevButton(6, params));
        }
        else
        {
            lineList.push(colNoButtons(6, 'colNoButtonPrev'));
        }

        if (props.nextButtonRequired)
        {
            lineList.push(colNextButton(6, params));
        } else if (props.saveButtonRequired)
        {
            lineList.push(colSaveButton(6, params));
        } else
        {
            lineList.push(colNoButtons(6, 'colNoButtonSave'));
        }

        return lineList;
    }

    return <div key={'navFormRowDiv'} className='row panel-body'>
        {buttonRowMultiPage(props.params)}
    </div>
}

export default NavRowComponent ;

